import React from 'react';
import distance from '@turf/distance';
import ReactDOM from 'react-dom';
import mapboxgl from 'mapbox-gl';
import { Popup } from './components';

export const returnAndSortLocalisedStores = (allstores, lng, lat) => {
  const newStores = { ...allstores };

  // CREATE DISTANCE (KM)
  newStores.features.forEach((store) => {
    Object.defineProperty(store.properties, 'distance', {
      value: distance([lng, lat], store.geometry.coordinates),
      writable: true,
      enumerable: true,
      configurable: true,
    });
  });

  // SORT BY DISTANCE
  newStores.features.sort((a, b) => {
    if (a.properties.distance > b.properties.distance) {
      return 1;
    }
    if (a.properties.distance < b.properties.distance) {
      return -1;
    }
    return 0;
  });

  newStores.features = [...newStores.features];

  return newStores;
};

export const removeStoresPopup = () => {
  const popUps = document.getElementsByClassName('mapboxgl-popup');
  if (popUps[0]) popUps[0].remove();
};

export const createPopUp = (map, currentFeature) => {
  const placeholder = document.createElement('div');

  ReactDOM.render(<Popup data={currentFeature.properties} />, placeholder);

  new mapboxgl.Popup({ offset: 18 })
    .setLngLat(currentFeature.geometry.coordinates)
    .setDOMContent(placeholder)
    .addTo(map);
};

export const flyToStore = (map, currentFeature) => {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 18,
  });
};

export const undoFlyToStore = (map, currentFeature) => {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 14,
  });
};

// Set clusters and markers on the map
export const initializeMapLayers = (map) => {
  map.addLayer({
    id: 'clusters',
    type: 'circle',
    source: 'stores-data',
    filter: ['has', 'point_count'],
    paint: {
      'circle-color': [
        'step',
        ['get', 'point_count'],
        '#707070',
        20,
        '#636363',
        30,
        '#474847',
      ],
      'circle-radius': ['step', ['get', 'point_count'], 20, 20, 30, 50, 40],
    },
  });

  map.addLayer({
    id: 'cluster-count',
    type: 'symbol',
    source: 'stores-data',
    filter: ['has', 'point_count'],
    layout: {
      'text-field': '{point_count_abbreviated}',
      'text-size': 12,
    },
    paint: {
      'text-color': '#ffffff',
    },
  });

  map.addLayer({
    id: 'unclustered-point',
    type: 'symbol',
    source: 'stores-data',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': 'nooz-marker',
      'icon-padding': 0,
      'icon-allow-overlap': true,
    },
  });
};

export const returnPointOnMapLength = (map) => {
  let pointLength = 0;

  map.queryRenderedFeatures({ layers: ['cluster-count'] }).forEach((count) => {
    pointLength += count.properties.point_count;
  });

  pointLength += map.queryRenderedFeatures({
    layers: ['unclustered-point'],
  }).length;

  // SET max lenght for the store list
  if (pointLength > 20) {
    pointLength = 20;
  }

  return pointLength;
};
